import React from 'react';

import { MenuItem } from '@mui/material';
import { IconMenuItem } from 'mui-nested-menu';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { TRecommendationTabs } from 'components/Dashboards/Project/Components/VersionCompare/utils/helper';
import { Button } from 'components/DesignSystem/Button';
import { Tabs } from 'components/DesignSystem/Tabs';
import { CustomizedDropdownMenu } from 'components/common';
import { useViewsManagerLogic } from 'components/pages/ScheduleViewsPage/ViewsManager/ViewsManager.logic';
import { UseViewsManagerProvider } from 'components/pages/ScheduleViewsPage/ViewsManager/ViewsManager.provider';
import { CreateNewViewModal } from 'components/pages/ScheduleViewsPage/ViewsManager/components/CreateNewViewModal/CreateNewViewModal';

import classes from './ViewsManager.module.scss';

const MENU_FONT_SIZE = '13px';

interface Props {
    isCreateViewModalOpen: boolean;
    setIsCreateViewModalOpen: (open: boolean) => void;
    api: UseViewsManagerProvider['api'];
}

export const ViewsManager = ({ api, isCreateViewModalOpen, setIsCreateViewModalOpen }: Props) => {
    const { logic } = useViewsManagerLogic({ api });

    return (
        <>
            <div className={classes.ViewsManager}>
                <div className={classes.leftSection}>
                    <Tabs
                        tabs={logic.tabs}
                        value={logic.activeTab}
                        onChange={(value) => logic.onTabChange(value as TRecommendationTabs)}
                        className={classes.tabsOverride}
                        isScrollAble={true}
                        isScrollButtons={true}
                    />
                </div>
                <div className={classes.rightSection}>
                    <Button
                        onClick={() => {
                            setIsCreateViewModalOpen(true);
                        }}
                        startIcon={<MuiIcon icon={'add'} color={'inherit'} />}
                        variant={'tertiary'}
                    >
                        Create view
                    </Button>
                    <CustomizedDropdownMenu
                        menuStyles={{ maxHeight: 'initial' }}
                        triggerElement={
                            <Button
                                startIcon={<MuiIcon icon={'visibility'} type={'outlined'} color={'inherit'} />}
                                endIcon={<MuiIcon icon={'keyboard_arrow_down'} color={'inherit'} />}
                                variant={'tertiary'}
                            >
                                Additional views
                            </Button>
                        }
                    >
                        {logic.additionalViews.length && logic.additionalViews.length > 0 ? (
                            logic.additionalViews
                        ) : (
                            <MenuItem>
                                <IconMenuItem
                                    sx={{
                                        '& .MuiTypography-root': {
                                            fontSize: MENU_FONT_SIZE,
                                            position: 'relative',
                                        },
                                        '& .MuiBox-root': {
                                            alignItems: 'center',
                                        },
                                    }}
                                    onClick={() => {}}
                                    label={'No additional items'}
                                />
                            </MenuItem>
                        )}
                    </CustomizedDropdownMenu>
                </div>
            </div>
            {isCreateViewModalOpen && (
                <CreateNewViewModal
                    setIsModalOpen={setIsCreateViewModalOpen}
                    isModalOpen={isCreateViewModalOpen}
                    onSubmit={logic.onCreateNewView}
                />
            )}
        </>
    );
};
